import { render, staticRenderFns } from "./UserACLAlert.vue?vue&type=template&id=f04e7ca4&scoped=true&"
import script from "./UserACLAlert.vue?vue&type=script&lang=js&"
export * from "./UserACLAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04e7ca4",
  null
  
)

export default component.exports